import { __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import NvButton from '../NvButton/NvButton.esm.js';

var NvLink = function (props) {
    return React.createElement(NvButton, __assign({}, props, { element: "a" }));
};

export { NvLink as default };
//# sourceMappingURL=NvLink.esm.js.map
